import { ComposeViewState } from 'owa-mail-compose-store';
import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import { action } from 'satcheljs/lib/legacy';

export default action('showBccWell')(function showBccWell(viewState: ComposeViewState) {
    if (!viewState.bccRecipientWell) {
        viewState.bccRecipientWell = createRecipientWell(viewState.findPeopleFeedbackManager, []);
    }
});
